import React from 'react';

class Zutat extends React.Component {
  constructor(props) {
    super(props);

    
    this.state = {
      zutat : this.props.zutatcontainer.zutat,
      menge : this.props.zutatcontainer.menge,
      einheit : this.props.zutatcontainer.einheit,
      deleteVisible : false,
      deleteElement: false
    };

     
    this.handleChange = this.handleChange.bind(this);
    this.proofDeletion = this.proofDeletion.bind(this);
  }
  
    handleChange(element, event) {
        switch(element) {
          case 'zutat':
          this.setState({ zutat: event.target.value });
        break;
        case 'menge':
              this.setState({ menge: event.target.value });
        break;
        case 'einheit':
            this.setState({ einheit: event.target.value });
        break;
        default:
        break;
      }
      if(event.target.value.length > 0) {
        this.setState({ deleteVisible: true });
      }
      let dataContainer = {};
      dataContainer.deleteElement = false;
      dataContainer.wert = event.target.value;
      dataContainer.element = element;
      dataContainer.keyzc = this.props.keyzc;
     this.props.onZutatElementChange(dataContainer);
    }
    proofDeletion(event) {
      event.preventDefault();
      let dataContainer = {};
      dataContainer.deleteElement = true;
      dataContainer.keyzc = this.props.keyzc;
      this.props.onZutatElementChange(dataContainer);

    }
    handleSubmit(event) {
       //event.preventDefault();
    }
    render() {
      
      let deleteVisible = "delete-button " +  ((this.state.deleteVisible === true) ? 'visible' : ' hidden');
      return (
        <li className="Component Zutat">
            <input name='menge'  type="text" value={this.state.menge} onChange={this.handleChange.bind(this, 'menge')} maxLength="4" placeholder="z.B. 1-1000" />
            <input name='einheit'  type="text" value={this.state.einheit} onChange={this.handleChange.bind(this, 'einheit')} maxLength="2" placeholder="z.B. g, kg, ml, TL, EL"  />
            <input name='zutat'  type="text" value={this.state.zutat} onChange={this.handleChange.bind(this, 'zutat')} maxLength="26" placeholder="z.B. Erbeeren, Schokolade, Milch, Knoblauchzehen" />
            <button className={deleteVisible}  onClick={ (e) => this.proofDeletion(e) } >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
        </li>
      )
    }
  }
  export default Zutat;


// WEBPACK FOOTER //
// ./src/Zutat.js